import { render, staticRenderFns } from "./Angiografia.vue?vue&type=template&id=e8257e1a"
import script from "./Angiografia.vue?vue&type=script&lang=js"
export * from "./Angiografia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports